var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLink = function SvgLink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1855_6669)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.755 6.76217C9.755 6.76217 10.7306 5.78876 11.8937 4.62571C14.0187 2.50076 17.4159 2.45268 19.4816 4.5183C21.5473 6.58392 21.4993 9.98105 19.3742 12.106L17.2365 14.2434M6.76231 9.75542C6.76231 9.75542 5.78887 10.731 4.62577 11.894C2.50075 14.019 2.45266 17.4161 4.51836 19.4817C6.58406 21.5473 9.98131 21.4992 12.1063 19.3743L14.2438 17.2367",
    stroke: "#282828",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 9L9 15",
    stroke: "#282828",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1855_6669"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
};
export default SvgLink;